import { useApplicantAddressFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantAddressFieldBindings";
import { defineComponent, ref, toRefs } from "@vue/composition-api";
import AddressFieldGroup from "@Shared/components/form-elements/field-groups/address-field-group.vue";
import TimeAtFieldGroup from "@Shared/components/form-elements/field-groups/time-at-field-group.vue";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { applicantAddressValidator } from "@Client/@Composables/application-standalone/validations/applicantAddressValidator";
export default defineComponent({
  name: "ApplicantAddress",
  components: {
    AddressFieldGroup,
    TimeAtFieldGroup,
    SectionTitle
  },
  props: {
    applicantIndex: {
      type: Number,
      required: true
    },
    addressIndex: {
      type: Number,
      required: true
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    showTimeWarning: {
      type: Boolean,
      default: false
    },
    multipleAddresses: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      applicantIndex,
      addressIndex
    } = toRefs(props);
    const addressFieldComponent = ref();
    const {
      applicantAddress
    } = useApplicantAddressFieldBindings({
      applicantIndex,
      addressIndex
    });
    const {
      v$
    } = applicantAddressValidator(applicantIndex, addressIndex);
    const showErrors = () => {
      var _addressFieldComponen;
      v$.value.$touch();
      (_addressFieldComponen = addressFieldComponent.value) == null ? void 0 : _addressFieldComponen.openManualAddress(true);
    };
    return {
      applicantAddress,
      v$,
      showErrors
    };
  }
});